import { Link } from 'react-router-dom';
import React from 'react';
import { Phone, Mail, ChevronRight } from 'lucide-react';

const CardsTeamPods = ({
  CardColor,
  name,
  role,
  secondaryRole,
  phone,
  email,
  PageRoute,
  isTeamLead = false
}) => {
  // Generate initials from name
  const getInitials = (name) => {
    if (!name) return 'TC';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <div className="team-member-card">
      {/* Header Section */}
      <div className="team-member-header">
        <div className="team-member-info">
          {isTeamLead && (
            <div className="team-lead-badge">
              <span className="team-lead-text">Team Lead</span>
            </div>
          )}
          <div className="team-member-name-section">
            <div className="team-member-avatar">
              <span className="team-member-initials">{getInitials(name)}</span>
            </div>
            <span className="team-member-name">{name || 'Team Member Name'}</span>
          </div>
        </div>

        {/* Contact Information */}
        <div className="team-member-contact">
          <div className="contact-item">
            <span className="contact-role">{role}</span>
          </div>
          {phone && (<div className="contact-item">
            <Phone className="contact-icon" size={14} />
            <span className="contact-text">{phone}</span>
          </div>)}
          <div className="contact-item">
            <Mail className="contact-icon" size={14} />
            <span className="contact-text">{email}</span>
          </div>
        </div>
      </div>

      {/* View Details Button */}
      <Link to={PageRoute} className="text-decoration-none">
        <div className="team-member-view-details-btn">
          <span className="view-details-text">View Details</span>
          <ChevronRight className="view-details-arrow" size={16} />
        </div>
      </Link>
    </div>
  );
};

export default CardsTeamPods;
